import React, { useMemo } from "react";
import { Cookies } from "react-cookie";
import { useSelector } from "react-redux";
import { PusherProvider } from "@activecollab/activecollab-react-pusher";
import PropTypes from "prop-types";
import Pusher from "pusher-js/with-encryption";
import { getIsOnDemand, getSocketIntegration } from "~/store/selectors/selector.configOptions.jsx";
import { api_url } from "~/utils/urls";

const cookie = new Cookies();

export const AppRealtimeProvider = ({ children }) => {
  const socketIntegration = useSelector(getSocketIntegration);
  const isOnDemand = useSelector(getIsOnDemand);

  const pusher = useMemo(() => {
    if (socketIntegration) {
      const authEndpoint = `${api_url}/socket/auth`;
      const options = {
        cluster: socketIntegration.app_cluster,
        authEndpoint,
        auth: {
          headers: {
            "X-Angie-CsrfValidator": cookie.get(window.csrfValidatorName),
          },
        },
      };

      if (socketIntegration.ws_host) {
        if (isOnDemand) {
          options.wsHost = socketIntegration.ws_host;
          options.wsPort = socketIntegration.ws_port;
        }

        options.enabledTransports = [`ws`];
        options.encrypted = true;
        options.disableStats = true;
      }

      return new Pusher(socketIntegration.app_key, options);
    }

    return {
      subscribe: () => ({
        bind: () => null,
        unbind: () => null,
        trigger: () => null,
      }),
      unsubscribe: () => null,
      connection: {
        bind: () => null,
        unbind: () => null,
      },
    };
  }, [isOnDemand, socketIntegration]);

  return <PusherProvider instance={pusher}>{children}</PusherProvider>;
};

AppRealtimeProvider.propTypes = {
  children: PropTypes.node,
};
